module.exports = __webpack_public_path__ + "static/img/8.d269904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/8.png
// module id = FLnP
// module chunks = 1 3